/*
 * last modified---
 * 	10-30-25 add Connect wallet prompt to <NoticeWrongNetwork/>
 * 	08-22-23 new
 *
 * purpose---
 * 	provide notices for incorrect (non-deployed) networks and missing artifacts
 */

import React from 'react';

// notice we have wrong network
function NoticeWrongNetwork() {
    return (
        <p>
            ⚠️ Selected wallet account is not connected to the site on the
			selected network.
			<br/>
			Connect browser wallet to site to access menu.
        </p>
    );
}

// notice we're not deployed here
function NoticeNoArtifact() {
    return (
        <p>
            ⚠️ Cannot find <span className="code">EnshroudProtocol</span>
            contract artifact.
        </p>
    );
}

export default NoticeWrongNetwork;
export { NoticeNoArtifact };
